import CSS from 'csstype';
import React from 'react';

import { FilterPillIconKey, FilterPillIcons } from '~/src/dash/components/filters/common';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { Col, Cols, fontSizing, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const colorScheme = {
  default: {
    color: publicaColors.black,
    backgroundColor: publicaColors.lightGray,
  },
  active: {
    color: publicaColors.jungleGreen,
    backgroundColor: publicaColors.honeydew,
  },
  disabled: {
    color: publicaColors.gray,
    backgroundColor: publicaColors.lightGray,
  },
} as Record<string, CSS.Properties>;

const getPillColor = (active: boolean, disabled: boolean) => {
  if (active) return colorScheme.active.color;
  if (disabled) return colorScheme.disabled.color;
  return colorScheme.default.color;
};

type PillSize = 'small' | 'base';

const sizeStyle = (size: PillSize): CSS.Properties => {
  switch (size) {
    case 'small':
      return {
        fontSize: fontSizing.small,
        borderRadius: '4px',
        padding: '4px 8px',
      };
    case 'base':
    default:
      return {
        fontSize: fontSizing.base,
        borderRadius: '6px',
        padding: '6px 10px',
      };
  }
};

interface IMobileFilterPillProps {
  active: boolean;
  children?: any; // this will override value and icon
  className?: string;
  disabled?: boolean;
  onClick: (props?: any | null) => void;
  style?: CSS.Properties;
  value?: string;
  icon?: FilterPillIconKey;
  size?: PillSize;
}

export const MobileFilterPill = ({
  active = false,
  className = '',
  disabled = false,
  onClick,
  size = 'base',
  style,
  value = '',
  children,
  icon,
}: IMobileFilterPillProps) => {
  const PillIcon = icon ? FilterPillIcons[icon] : undefined;

  return (
    <button
      onClick={disabled ? () => null : onClick}
      className={className}
      style={{
        display: 'inline-block',
        borderWidth: 0,
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        fontStyle: 'inherit',
        whiteSpace: 'nowrap',
        margin: 0,
        fontWeight: FONT_WEIGHT.bold,
        minWidth: '40px',
        textAlign: 'center',
        ...sizeStyle(size),
        ...colorScheme.default,
        ...(disabled ? colorScheme.disabled : {}),
        ...(active ? colorScheme.active : {}),
        ...style,
      }}
    >
      {children || (
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          {PillIcon && (
            <Col style={PillIcon.style}>
              <PillIcon.SvgComponent color={getPillColor(active, disabled)} />
            </Col>
          )}
          <Col>{value}</Col>
        </Cols>
      )}
    </button>
  );
};
